module.exports = __webpack_public_path__ + "static/pr-op-real-updates@2x-9c69551e9a77b18d2dbab8b1171adc99.png";